import { Layout, theme } from 'antd';
import React, { useEffect, useState } from 'react';
import Footers from '../components/Footer';
import Headers from '../components/Header';
import Siders from '../components/Sider';
import { useNavigate } from 'react-router-dom';
import AddPers from '../components/AddPersonal';

const { Content } = Layout;

const AppPresss = () => {
    const {
        token: { colorBgContainer },
    } = theme.useToken();

    return (
        <Layout
            style={{
                minHeight: '100vh',
            }}
        >
            <Siders />
            <Layout>
                <Headers />
                <Content
                    className="site-layout"
                    style={{
                        padding: '0 10px',
                    }}
                >
                    <div
                        style={{
                            padding: 4,
                            minHeight: 380,
                            background: colorBgContainer,
                        }}
                    >
                        <AddPers />
                    </div>
                </Content>
                <Footers />
            </Layout>
        </Layout>
    );
};

export default AppPresss;
